module.exports = __webpack_public_path__ + "static/media/bnr_top_sp.1bf4d169.jpg";